// extracted by mini-css-extract-plugin
export default {"td":"PersonalizacaoFolhaIndex_td__lu5xd","td2":"PersonalizacaoFolhaIndex_td2__m-ESY","inscricao":"PersonalizacaoFolhaIndex_inscricao__Ygs0j"};